<div class="row" *ngIf="listsLoaded==false">

  <div class="col-sm-12">
    One moment please...
  </div>

</div>

<div class="row " *ngIf="listsLoaded==true">

  <div class="col-sm-12 searchControls">
    
    <div class='gridCell'> 
      <div> 
          <label for="">Lectionary Source</label>
          <select [(ngModel)]="model.LectionarySource"   >
            <option></option>
            <option *ngFor="let section of lectionarySources" [ngValue]="section.Id">
              {{section.NameAbbreviated}}
            </option>
          </select> 
      </div>
    </div>

    <div class='gridCell'>
        <div> 
          
            <label for="">Chapter</label>
            <select  [(ngModel)]="model.Chapter"  >
              <option></option>
              <option *ngFor="let chapter of chapters" [ngValue]="chapter">
                {{chapter}}
              </option>
            </select> 
        </div>
    </div>
 
 
        <div class='gridCell' style="align-self:end">
            <button (click)="search()">Search</button>
        </div> 
 
  </div>
 

</div>